import React from 'react';
import { Box, Button, Divider, Flex, Typography } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';

// Most library components want to limit ORing to 10 elements.
export const defaultOrControlLimit = 10;

export const OrControl = (props: {
  disabled?: boolean;
  onClick?: () => void;
  omitVerticalPadding?: boolean;
  testId?: string;
}) => (
  <Flex alignItems="center" justifyContent="flex-start">
    <Box width={props.onClick ? 16 : 24}>
      <Divider variant="medium" />
    </Box>
    <Box padding={props.omitVerticalPadding ? [0, 8, 0, 8] : 8}>
      {props.onClick ? (
        <Button
          testId={props.testId ?? 'or-button'}
          size="x-small"
          variant="fill-builder"
          disabled={props.disabled}
          onClick={props.onClick}
        >
          <FormattedMessage
            defaultMessage="or"
            id="U5i4iA"
            description="Used to indicate that two or more elements apply (e.g element x or element y)"
          />
        </Button>
      ) : (
        <Typography color="neutrals-n7" variant="body3">
          <FormattedMessage
            defaultMessage="or"
            id="U5i4iA"
            description="Used to indicate that two or more elements apply (e.g element x or element y)"
          />
        </Typography>
      )}
    </Box>
    <Divider variant="medium" />
  </Flex>
);
